import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const sendWhatsappApi = async (payload = {}, authHeaders = {}) => {
  try {

    if (payload.operation === 'BULK_MESSAGE') {
      const body = {
        operation: 'BULK_MESSAGE',
        companyId: payload.companyId,
        wabaId: payload.wabaId,
        csvUrl: payload.csvUrl,
        fileName: payload.fileName || undefined,
        mapping: payload.mapping || undefined,
        templateId: payload.templateId,
        templateParams: payload.templateParams || undefined,
        useCase: payload.useCase,
        useCaseId: payload.useCaseId,
        displayPhoneNumberId: payload.displayPhoneNumberId
      };

      const res = await apiCallPost(apiPaths.whatsapp, body, authHeaders);

      if (res && typeof res === 'object' && (res.status === 'success' || String(res.status).toUpperCase() === 'QUEUED' || String(res.status).toUpperCase() === 'SUCCESS')) {
        return { data: res, status: true, msg: 'Bulk message request accepted' };
      }

      return { data: {}, status: false, errMsg: res?.errMsg || 'Failed to send bulk WhatsApp message' };
    }

    const body = {
      complaintId: payload.complaintId,
      phone: payload.phone,
      templateId: payload.templateId,
      wabaId: payload.wabaId,
      displayPhoneNumberId: payload.displayPhoneNumberId,
      companyId: payload.companyId,
      messageType: payload.messageType,
      useCase: payload.useCase,
      useCaseId: payload.useCaseId,
      templateParams: payload.templateParams || undefined
    };

    const res = await apiCallPost(apiPaths.whatsapp, body, authHeaders);

    if (res && Array.isArray(res) && res.length > 0 && res[0].status === 'success') {
      return { data: res[0], status: true, msg: `WhatsApp message sent successfully. Request ID: ${res[0].requestId}` };
    }

    if (res && typeof res === 'object' && (String(res.status).toUpperCase() === 'QUEUED' || String(res.status).toUpperCase() === 'SUCCESS')) {
      const msgId = res.messageUUID || res.requestId || '';
      return { data: res, status: true, msg: `WhatsApp message ${String(res.status).toLowerCase()}${msgId ? `. ID: ${msgId}` : ''}` };
    }

    return { data: {}, status: false, errMsg: 'Failed to send WhatsApp message' };
  } catch (err) {
    return { status: false, errMsg: err.message || 'Failed to send WhatsApp message' };
  }
};